import { Component, OnInit } from '@angular/core';
import { LanguageService } from 'src/app/services/language.service';

@Component({
    selector: 'app-profile-help',
    templateUrl: './profile-help.component.html',
    styleUrls: ['./profile-help.component.scss'],
    standalone: false
})
export class ProfileHelpComponent implements OnInit {

  constructor(public languageService:LanguageService) { }

  ngOnInit(): void {
  }

}
